module.exports = __webpack_public_path__ + "static/img/BK2.5fd47f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK2.png
// module id = aGkS
// module chunks = 9